import Vue from 'vue'
import VueRouter from 'vue-router'
import WebviewHome from '../views/webview/WebviewHome.vue'
import PainelLogin from '../views/painel/login/PainelLogin.vue'
import PainelHome from '../views/painel/home/PainelHome.vue'
import PainelDashboard from '../views/painel/dashboard/PainelDashboard.vue'
import GraficoSalas from '../views/painel/grafico-salas/GraficoSalas.vue'
import LogsMovimentacoes from '../views/painel/logs-movimentacoes/LogsMovimentacoes.vue'
import SalasTempoReal from '../views/painel/salas-tempo-real/SalasTempoReal.vue'
import { isAuthenticated } from '../views/painel/service/auth.service.js'

Vue.use(VueRouter)

const isDevelopment = process.env.VUE_APP_ENVIRONMENT === 'development'

const routes = [
  {
    path: '/',
    name: 'webviewHome',
    component: WebviewHome
  },
  {
    path: '/atendimento',
    name: 'callEnter',
    component: WebviewHome
  },
  {
    path: '/painel',
    name: 'painelLogin',
    component: PainelLogin,
    meta: { guestOnly: true }
  },
  {
    path: '/painel/dashboard',
    name: 'painelDashboard',
    component: PainelHome,
    meta: { requiresAuth: true }
  },
  {
    path: '/painel/logs-movimentacoes',
    name: 'painelLogsMovimentacoes',
    component: LogsMovimentacoes,
    meta: { requiresAuth: true }
  },
  {
    path: '/painel/salas-registradas',
    name: 'painelSalasRegistradas',
    component: PainelDashboard,
    meta: { requiresAuth: true }
  },
  {
    path: '/painel/salas',
    name: 'painelSalas',
    component: SalasTempoReal,
    meta: { requiresAuth: true, title: 'Salas em Tempo Real' }
  },
  {
    path: '/painel/grafico',
    name: 'painelGrafico',
    component: GraficoSalas,
    meta: { requiresAuth: true, title: 'Gráfico das Salas Criadas' }
  },
  {
    path: '*',
    redirect: () => (isDevelopment ? '/' : '/painel')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  const authenticated = isAuthenticated()
  if (!isDevelopment && to.name === 'webviewHome') {
    return next({ name: 'painelLogin' })
  }

  if (to.name === 'callEnter') {
    return next()
  }

  if (to.meta.requiresAuth && !authenticated) {
    return next({ name: 'painelLogin' })
  }

  if (to.meta.guestOnly && authenticated) {
    return next({ name: 'painelDashboard' })
  }

  next()
})

export default router
